import { useFlag, useFlagsStatus } from '@unleash/proxy-client-react';
import { useState, useEffect } from 'react';

// This hook can be used anywhere where feature flag status is needed (potentially when showing or hiding nav items)
export function useCheckFeatureFlag(flagName: string) {
  const enabled = useFlag(flagName);
  const { flagsReady } = useFlagsStatus();

  const [flagStatus, setFlagStatus] = useState<boolean>(false);

  useEffect(() => {
    if (flagsReady) {
      setFlagStatus(enabled);
    }
  }, [enabled, flagsReady]);

  if (flagName === '') {
    return true;
  }

  return flagStatus;
}
